import { caseInsensitiveContainsFilterOption } from '@lib/filter';
import { getClosestViewArea } from '@lib/popups';
import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { useUsers } from '@hooks';
import { Form, Select } from 'antd';
import React, { useMemo } from 'react';
function getOptions(users) {
    return users
        .filter((user) => !user.isLocked)
        .map((user) => {
        const { fullName, id } = user;
        return {
            label: fullName,
            value: String(id)
        };
    });
}
export const TagOwnersInput = ({ disabled, name }) => {
    const users = useUsers();
    const options = useMemo(() => getOptions(users), [users]);
    return (React.createElement(Form.Item, { className: 'tag-owners-input', name: name },
        React.createElement(Select, { allowClear: !disabled, disabled: disabled, filterOption: caseInsensitiveContainsFilterOption, getPopupContainer: getClosestViewArea, mode: 'multiple', options: options, placeholder: PLACEHOLDERS_COPY.TAG_OWNERS })));
};
